module.exports = __webpack_public_path__ + "media/images/announceGroup__bg-1fc4eae94e094f5cd32f4699161f1f07.jpg";